var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_803_39995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3335 8.6665L4.85647 9.71244C5.03346 10.0664 5.12196 10.2434 5.24018 10.3968C5.34509 10.5329 5.4671 10.6549 5.6032 10.7598C5.75658 10.878 5.93356 10.9666 6.28755 11.1435L7.3335 11.6665L6.28755 12.1895C5.93356 12.3664 5.75658 12.455 5.6032 12.5732C5.4671 12.6781 5.34509 12.8001 5.24018 12.9362C5.12196 13.0896 5.03346 13.2666 4.85647 13.6206L4.3335 14.6665L3.81052 13.6206C3.63353 13.2666 3.54504 13.0896 3.42681 12.9362C3.3219 12.8001 3.19989 12.6781 3.0638 12.5732C2.91042 12.455 2.73343 12.3664 2.37944 12.1895L1.3335 11.6665L2.37944 11.1435C2.73343 10.9666 2.91042 10.878 3.0638 10.7598C3.19989 10.6549 3.3219 10.5329 3.42681 10.3968C3.54504 10.2434 3.63353 10.0664 3.81052 9.71244L4.3335 8.6665Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.3335L10.7859 3.37644C10.9739 3.86526 11.0679 4.10967 11.2141 4.31526C11.3437 4.49746 11.5028 4.65666 11.6851 4.78622C11.8906 4.9324 12.1351 5.02641 12.6239 5.21442L14.6668 6.00016L12.6239 6.7859C12.1351 6.9739 11.8906 7.0679 11.6851 7.2141C11.5028 7.3437 11.3437 7.50283 11.2141 7.6851C11.0679 7.89063 10.9739 8.1351 10.7859 8.6239L10.0002 10.6668L9.21443 8.6239C9.02643 8.1351 8.93243 7.89063 8.78623 7.6851C8.65663 7.50283 8.4975 7.3437 8.31523 7.2141C8.1097 7.0679 7.86523 6.9739 7.37643 6.7859L5.3335 6.00016L7.37643 5.21442C7.86523 5.02641 8.1097 4.9324 8.31523 4.78622C8.4975 4.65666 8.65663 4.49746 8.78623 4.31526C8.93243 4.10967 9.02643 3.86526 9.21443 3.37644L10.0002 1.3335Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_803_39995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsBlack);
export default __webpack_public_path__ + "static/media/stars_black.ab36162f8aec8751d2f166e8c4595668.svg";
export { ForwardRef as ReactComponent };